import { useField } from 'formik';

interface InputFormikProps {
  label: string;
  name: string;
  className?: string;
  readonly?: boolean;
  placeholder?: string;
  value?: string;
}

const TextareaFormik: React.FC<InputFormikProps> = ({
  name,
  className,
  readonly,
  placeholder,
}) => {
  const [field] = useField(name);

  return (
    <div>
      <label htmlFor={name}></label>
      <textarea
        id={name}
        {...field} // já traz value e onChange do Formik
        readOnly={readonly}
        className={className}
        placeholder={placeholder}
        wrap="soft"
      />
    </div>
  );
};

export default TextareaFormik;
